let TOAST_ID = 1;

export const genToastId = () => `${TOAST_ID++}`;
